import { Component, EventEmitter, Input, NgZone, OnChanges, Output, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { GridComponent, GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { process, State, orderBy } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { CRMService } from '../../services/crm.service';
import { UtilService } from '../../services/util.service';
import {
    OpportunityQuestion
} from '../../models/models';

@Component({
    selector: 'opportunity-question-grid',
    templateUrl: './opportunity-question-grid.component.html',
    standalone: false
})
export class OpportunityQuestionGrid implements OnChanges {
    @Input() tableID: number = 0;
    @Input() tableHeader: string = "Opportunity Questions";
    @Output() onRefresh = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public tableGrid!: GridComponent;

    public isAdd: boolean = false;
    public isEdit: boolean = false;

    public tableList: OpportunityQuestion[] = [];
    public tableItem: OpportunityQuestion = {} as OpportunityQuestion;
    public employeeID: number = 0;

    public gridData: GridDataResult = { data: [], total: 0 };
    public gridState: State = { skip: 0, take: 0, sort: [{ dir: 'asc', field: "sortOrder" }] };

    constructor(private crmService: CRMService, private utilService: UtilService, private dialog: MatDialog, private ngZone: NgZone) {
    }

    ngOnChanges() {
        this.getTableList();
    }

    private getTableList() {
        this.utilService.isLoading = true;
        this.crmService.getOpportunityQuestionsByCategoryID(this.tableID).subscribe(result => {
            this.utilService.isLoading = false;
            this.tableList = result.resultCollection;
            this.setGrid();
        });
    }

    private setGrid() {
        if (this.gridState.sort) this.tableList = orderBy(this.tableList, this.gridState.sort);

        this.gridData = process(this.tableList, this.gridState);
        this.fitColumns();
    }

    private fitColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.tableGrid == null) return;
            this.tableGrid.autoFitColumns();
        });
    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.gridState = state;
        this.setGrid();
    }

    public save() {
        this.crmService.saveOpportunityQuestion(this.tableItem).subscribe(result => {
            this.isAdd = false;
            this.isEdit = false;
            this.getTableList();
        });
    }

    public addNew() {
        this.tableItem = {
            opportunityQuestionID: 0,
            opportunityQuestionCategoryID: this.tableID,
            question: "",
            sortOrder: 0,
            retired: false
        };
        this.isAdd = true;
    }

    public edit(item: OpportunityQuestion) {
        this.tableItem = item;
        this.isEdit = true;
    }

    public cancel() {
        this.isAdd = false;
        this.isEdit = false;
        this.getTableList();
    }

    public close() {
        this.isAdd = false;
        this.isEdit = false;
        this.onRefresh.emit();
    }
}
